<div class="felter" [formGroup]="skjema()">
    <div class="hovedfelter">
        <mat-form-field class="type">
            <mat-label>{{ 'Type' | translate }}</mat-label>
            <mat-select [formControl]="skjema().controls.type" data-testid="type-felt">
                @for (type of spoersmaalstyper; track type.verdi) {
                    <mat-option [value]="type.verdi">{{ type.navn | translate }}</mat-option>
                }
            </mat-select>
        </mat-form-field>

        <mat-form-field class="tittel">
            <mat-label>
                @if (erGruppe()) {
                    {{ 'Gruppetittel' | translate }}
                } @else {
                    {{ 'Spørsmål' | translate }}
                }
            </mat-label>
            <input matInput [formControl]="skjema().controls.tittel" data-testid="tittel-felt">
            @if (skjema().controls.tittel.hasError('required')) {
                <mat-error>{{ 'Tittel må fylles ut' | translate }}</mat-error>
            }
            @if (skjema().controls.tittel.hasError('maxlength')) {
                <mat-error>{{ 'Tittelen er for lang' | translate }}</mat-error>
            }
        </mat-form-field>

        @if (!erLaast()) {
            <button mat-icon-button type="button" class="slett" (click)="slett.emit()" [attr.aria-label]="'Slett spørsmål' | translate" data-testid="slett-spoersmaal-knapp">
                <mat-icon fontSet="ion-ios-trash-outline" class="mat-icon--ionic-ikon"/>
            </button>
        }
    </div>

    @if (korrelerteSpoersmaal().length > 0) {
        @if (avvikendeKorrelerte().length > 0) {
            <inline-melding type="advarsel" class="korrelasjon" data-testid="korrelasjon-brytes">
                {{ 'Endret type eller svaralternativer gjør at resultatene ikke lenger kan sammenliknes med spørsmålene under. Sammenlikningen brytes når skjemaet lagres, tilbakestill endringen for å beholde den.' | translate }}
                <ul class="korrelerte-spoersmaal">
                    @for (korrelert of korrelerteSpoersmaal(); track korrelert.spoersmaal.id) {
                        <li>{{ '«{spoersmaal}» i skjemaet «{skjema}»' | translate: {spoersmaal: korrelert.spoersmaal.tittel, skjema: korrelert.skjematittel} }}</li>
                    }
                </ul>
            </inline-melding>
        } @else {
            <div class="korrelasjon" data-testid="korrelerte-spoersmaal">
                <span class="korrelasjon-overskrift">{{ 'Resultatene sammenliknes med:' | translate }}</span>
                <ul class="korrelerte-spoersmaal">
                    @for (korrelert of korrelerteSpoersmaal(); track korrelert.spoersmaal.id) {
                        <li>{{ '«{spoersmaal}» i skjemaet «{skjema}»' | translate: {spoersmaal: korrelert.spoersmaal.tittel, skjema: korrelert.skjematittel} }}</li>
                    }
                </ul>
            </div>
        }
    }

    <mat-form-field class="beskrivelse">
        <mat-label>{{ 'Beskrivelse' | translate }}</mat-label>
        <riktekst-redigering [skjemakontroll]="skjema().controls.beskrivelse"/>
    </mat-form-field>

    @if (visAlternativer()) {
        <div class="alternativer" data-testid="alternativer">
            <div class="alternativer-overskrift">{{ 'Svaralternativer' | translate }}</div>
            <mat-form-field class="alternativkilde">
                <mat-label>{{ 'Bruk' | translate }}</mat-label>
                <mat-select [value]="valgtAlternativkildeVerdi()" (selectionChange)="velgAlternativkilde($event.value)" [disabled]="erLaast()" data-testid="alternativkilde-felt">
                    <mat-option [value]="egneAlternativer">{{ 'Egne alternativer' | translate }}</mat-option>
                    @for (kandidat of alternativkandidater(); track kandidat) {
                        <mat-option [value]="kandidat">{{ 'Samme som: {tittel}' | translate: {tittel: kandidattittel(kandidat)} }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
            @if (valgtAlternativkilde()) {
                <div class="kildens-alternativer" data-testid="kildens-alternativer">
                    @for (alternativ of kildensAlternativer(); track $index) {
                        <div class="kildens-alternativ">
                            <span class="fargeprikk" [style.background-color]="alternativ.farge"></span>
                            <span class="alternativ-tittel">{{ alternativ.tittel }}</span>
                            <span class="verdi">{{ alternativ.verdi }}</span>
                        </div>
                    }
                </div>
            } @else {
                @for (alternativ of skjema().controls.alternativer.controls; track alternativ; let indeks = $index) {
                    <div class="alternativ" data-testid="alternativ">
                        <input type="color" class="farge" [formControl]="alternativ.controls.farge" [attr.aria-label]="'Farge' | translate">
                        <mat-form-field class="alternativ-tittel">
                            <mat-label>{{ 'Alternativ' | translate }}</mat-label>
                            <input matInput [formControl]="alternativ.controls.tittel" data-testid="alternativ-tittel-felt">
                            @if (alternativ.controls.tittel.hasError('required')) {
                                <mat-error>{{ 'Tittel må fylles ut' | translate }}</mat-error>
                            }
                        </mat-form-field>
                        <span class="verdi" [title]="'Verdien som lagres for alternativet' | translate">{{ alternativ.controls.verdi.value }}</span>
                        @if (!erLaast()) {
                            <button mat-icon-button type="button" (click)="fjernAlternativ(indeks)" [attr.aria-label]="'Fjern alternativ' | translate" data-testid="fjern-alternativ-knapp">
                                <mat-icon fontSet="ion-ios-close-empty" class="mat-icon--ionic-ikon"/>
                            </button>
                        }
                    </div>
                }
                @if (skjema().hasError('manglerAlternativer')) {
                    <mat-error>{{ 'Spørsmålet må ha minst ett svaralternativ' | translate }}</mat-error>
                }
                @if (!erLaast()) {
                    <button mat-button type="button" (click)="leggTilAlternativ()" data-testid="legg-til-alternativ-knapp">
                        {{ '+ Legg til alternativ' | translate }}
                    </button>
                }
            }
            @if (visMaksimaltAntallValg()) {
                <mat-form-field class="maksimalt-antall-valg">
                    <mat-label>{{ 'Maksimalt antall avkrysninger' | translate }}</mat-label>
                    <input matInput type="number" min="1" step="1" [formControl]="skjema().controls.maksimaltAntallValg" data-testid="maksimalt-antall-valg-felt">
                    <mat-hint>{{ 'La feltet stå tomt for ingen begrensning' | translate }}</mat-hint>
                </mat-form-field>
                @if (skjema().hasError('ugyldigMaksimaltAntallValg')) {
                    <mat-error>{{ 'Maksimalt antall avkrysninger må være et heltall mellom 1 og antall alternativer ({antall})' | translate: {antall: skjema().getError('ugyldigMaksimaltAntallValg').antallAlternativer} }}</mat-error>
                }
            }
        </div>
    }
</div>
